import { getGolfPlayerCategory } from "../utils/appUtils";
import Avatar from "./Avatar";
import { Strong } from "./catalyst/text";
import { Text } from "./catalyst/text";

export const PlayerRecord: React.FC<any> = ({
  member,
  showHandicapAndMsl = true,
  avatarOnly = false,
}) => {
  if (!member) {
    return <div className="flex-1">No member</div>;
  }
  return (
    <div className="flex-1 flex flex-row items-center gap-3">
      <div className="flex-1 flex flex-row items-center">
        <Avatar
          firstName={member.firstName}
          lastName={member.lastName}
          imageUrl={`/api/static/images/${member.profilePicture}`}
          className="h-6 w-6 rounded-full"
        />
        {!avatarOnly && (
          <div className="pl-1">
            <Strong className="text-md font-semibold">
              {member.title} {member.firstName} {member.lastName}
            </Strong>
          </div>
        )}
      </div>
      {showHandicapAndMsl && (
        <>
          <div className="w-2 text-center">
            <Text className="text-md font-semibold">
              {member.playerHandicap}
            </Text>
          </div>
          <div className="w-3 text-center mx-2">
            <Text className="text-md font-semibold">
              {getGolfPlayerCategory(member.ageCategory, member.gender)}
            </Text>
          </div>
        </>
      )}
    </div>
  );
};
